(() => {
  if (!customElements.get('gb-slider')) {
    class GbSlider extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.track = this.querySelector('[data-gb-track]');
        if (!this.track) return;
        this.ready = true;
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-gb-prev]');
        this.next = this.querySelector('[data-gb-next]');
        this.counter = this.querySelector('[data-gb-count]');
        this.previous?.addEventListener('click', () => this.move(-1), opts);
        this.next?.addEventListener('click', () => this.move(1), opts);
        this.track.addEventListener('scroll', () => this.update(), { ...opts, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, opts);
        if (typeof ResizeObserver !== 'undefined') {
          this.observer = new ResizeObserver(() => this.update()); this.observer.observe(this.track);
        }
        this.update();
      }
      step() { return (this.track.firstElementChild?.getBoundingClientRect().width || this.track.clientWidth) + (parseFloat(getComputedStyle(this.track).columnGap) || 0); }
      move(direction) { this.track.scrollBy({ left: this.step() * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
        if (this.counter) this.counter.textContent = `${Math.min(this.track.children.length, Math.round(this.track.scrollLeft / this.step()) + 1)} / ${this.track.children.length}`;
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.ready = false; }
    }
    customElements.define('gb-slider', GbSlider);
  }
  if (!customElements.get('gb-film')) {
    class GbFilm extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController(); const opts = { signal: this.controller.signal };
        const video = this.querySelector('video'), button = this.querySelector('[data-gb-film-toggle]');
        if (!video || !button) return;
        button.hidden = false;
        const sync = () => { button.textContent = video.paused ? 'Play film' : 'Pause film'; button.setAttribute('aria-label', video.paused ? 'Play homepage film' : 'Pause homepage film'); };
        video.addEventListener('play', sync, opts); video.addEventListener('pause', sync, opts);
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
        button.addEventListener('click', () => { if (video.paused) video.play().catch(() => sync()); else video.pause(); }, opts);
        sync();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    }
    customElements.define('gb-film', GbFilm);
  }
})();
